import {VehicleRegistrationDetailsGroup} from '../../kit/groups/VehicleRegistrationDetailsGroup';
import {VehicleForm as VFKit} from '../../kit/VehicleForm';

export function VehicleRegistrationSubSection() {
  return (
    <VFKit.SubSection data-testid="vehicle-registration">
      <VFKit.Group data-testid="vehicle-registration-details" columns={[1, 2, 4]}>
        <VehicleRegistrationDetailsGroup />
      </VFKit.Group>
    </VFKit.SubSection>
  );
}
